import { Label } from '@customerio/pluma-components/react';
import type { BackfillState } from '../utils/backfill';

export const STATE_LABELS: Record<BackfillState, string> = {
  Queued: 'Queued',
  InProgress: 'In Progress',
  Failure: 'Failure',
  Success: 'Success',
  Retrying: 'Retrying',
  Canceled: 'Canceled',
};

const STATE_LABEL_COLORS: Record<BackfillState, 'grey' | 'blue' | 'red' | 'yellow' | 'green'> = {
  Queued: 'grey',
  InProgress: 'yellow',
  Failure: 'red',
  Success: 'green',
  Retrying: 'yellow',
  Canceled: 'grey',
};

export interface TaskStateBadgeProps {
  state: BackfillState;
}

export function TaskStateBadge({ state }: TaskStateBadgeProps) {
  const color = STATE_LABEL_COLORS[state];
  const label = STATE_LABELS[state];

  return <Label color={color}>{label}</Label>;
}
